import { useImportCancelConfirmModal } from '@/features/import_export_histories/Table/hooks/useImportCancelConfirmModal';
import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { FC, memo, useCallback, useState } from 'react';

type Props = {
  onClick: () => Promise<void>;
  isDisabled?: boolean;
};

export const CancelButton: FC<Props> = memo(
  ({ onClick: _onClick, isDisabled = false }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const { confirm, ConfirmModal } = useImportCancelConfirmModal();

    const onClick = useCallback(async () => {
      const confirmed = await confirm();
      if (!confirmed) return;
      setIsLoading(true);
      try {
        await _onClick();
      } finally {
        setIsLoading(false);
      }
    }, [_onClick, confirm]);

    return (
      <>
        <ButtonV2
          color='primary'
          isSecondary
          isTransparent
          size='xs'
          onClick={onClick}
          isLoading={isLoading}
          isDisabled={isDisabled}
        >
          {t('import_export_history_cancel')}
        </ButtonV2>
        <ConfirmModal />
      </>
    );
  }
);

CancelButton.displayName = 'CancelButton';
